import isEmpty from 'lodash/isEmpty'

export default {
  computed: {
    currentUserPresent() {
      return isEmpty(this.$store.state.currentUser) !== true
    }
  }
}
